import { render, staticRenderFns } from "./ClientCases.vue?vue&type=template&id=534400ac&scoped=true&"
import script from "./ClientCases.vue?vue&type=script&lang=js&"
export * from "./ClientCases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534400ac",
  null
  
)

export default component.exports